var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"LoginLogo"},[_c('img',{attrs:{"src":_vm.props.brandLogos.main}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb81be42","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/LoginLogo/index.vue
// module id = 1294
// module chunks = 3